import {HTMLAttributes} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Maybe} from '../../../graphql/generated/types';
import {Icon} from '../Icon/Icon';
import {IconType} from '../Icon/IconType.enum';
import {RankingType} from './RankingType.enum';

export interface RankingProps extends HTMLAttributes<HTMLDivElement> {
  type: RankingType;
  rank?: Maybe<string>;
  rankVariation?: Maybe<number>;
}

export function Ranking({
  type,
  rank,
  rankVariation,
  className,
  ...props
}: RankingProps) {
  return (
    <div
      className={twMerge(
        'flex w-68pxr rounded-[5px] px-4pxr under-320-view:w-56pxr',
        type === RankingType.Static && 'bg-static-mono-90',
        type === RankingType.Theme && 'bg-theme-solid-10',
        className
      )}
      {...props}
    >
      <div
        className={twMerge(
          'font-small2-bold flex-1',
          type === RankingType.Static && 'text-static-mono-white',
          type === RankingType.Theme && 'text-theme-solid-100'
        )}
      >
        {rank}
      </div>
      <>
        <Icon
          type={
            rankVariation === 0
              ? IconType.RankingStayStatic
              : rankVariation && rankVariation < 0
                ? IconType.RankingArrowDownStatic
                : rankVariation && rankVariation > 0
                  ? IconType.RankingArrowUpStatic
                  : IconType.RankingNewStatic
          }
        />
        <div className="font-x-small2-bold text-static-mono-40 under-320-view:hidden">
          {rankVariation ? Math.abs(rankVariation) : null}
        </div>
      </>
    </div>
  );
}
